/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section2_Li2Inputs */

const en_terms_section2_li2 = /** @type {(inputs: Terms_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON conversion to other formats (TypeScript, YAML, CSV, XML)`)
};

const ko_terms_section2_li2 = /** @type {(inputs: Terms_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 다른 형식으로 변환 (TypeScript, YAML, CSV, XML)`)
};

const ja_terms_section2_li2 = /** @type {(inputs: Terms_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの他形式への変換（TypeScript、YAML、CSV、XML）`)
};

/**
* | output |
* | --- |
* | "JSON conversion to other formats (TypeScript, YAML, CSV, XML)" |
*
* @param {Terms_Section2_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section2_li2 = /** @type {((inputs?: Terms_Section2_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section2_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section2_li2(inputs)
	if (locale === "ko") return ko_terms_section2_li2(inputs)
	return ja_terms_section2_li2(inputs)
});